module.exports = __webpack_public_path__ + "img/ranking_candidatos.641c8b6c.png";